import { render, staticRenderFns } from "./GoalSettingsContent.vue?vue&type=template&id=5351979e&scoped=true"
import script from "./GoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./GoalSettingsContent.vue?vue&type=script&lang=js"
import style0 from "./GoalSettingsContent.vue?vue&type=style&index=0&id=5351979e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351979e",
  null
  
)

export default component.exports